import "./index.css";

const CourseDetailDesc = ({ name, desc }) => {
  return (
    <div className="education-intro-desc" style={{ width: "100%" }}>
      <h5>{name}</h5>
      <p style={{ marginBottom: "10px" }}>{desc}</p>
    </div>
  );
};

export default CourseDetailDesc;
